import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { findMatchingRedirectRule } from '../config/redirectConfig';

/**
 * Custom hook to handle automatic route redirects based on hostname and path
 * Uses the centralized redirect configuration to determine when to redirect
 */
export const useRouteRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentHostname = window.location.hostname;
    const matchingRule = findMatchingRedirectRule(currentHostname, location.pathname);

    if (matchingRule) {
      navigate(matchingRule.toPath, { replace: true });
    }
  }, [location.pathname, navigate]);
};
